import { EnvironmentConfig } from 'src/config/types';
import { getEnv } from 'src/server/lib/getEnv';
import { CENTRAL_API_PREFIX } from 'src/shared/constants';

export default (): EnvironmentConfig => ({
    environment: 'development',
    clusterSuffix: 'local',
    credentialsPath: '',
    cdnHost: '',
    webpackManifest: '',
    services: {
        tracking: 'https://pegasus-zl-skipper.lounge-test.zalan.do/proxy/tracking',
        contentful: 'https://pegasus-contentful-proxy.lounge-test.zalan.do',
        onboarding_sdk: 'https://zl-acquire-production.ztat.net/sdk/master-6/sdk.js',
        octopusService: 'https://assignment-service.economics.zalan.do',
        sentry: '--redefine--',
    },
    timings: {
        contentRenderingThrottling: 500,
    },
    version: String(process.env.CDP_BUILD_VERSION),
    contentful: {
        spaceToken: getEnv('CONTENTFUL_TOKEN'),
        spaceId: 'gscn32h7ckds',
        host: 'preview.contentful.com',
    },
    url: {
        assetsBase: '',
        items: '',
    },
    security: {
        csrf: {
            errorPath: '', // TODO: Add the right path for error redirection.
            allowlist: [],
        },
        auth: {
            allowlist: [
                `${CENTRAL_API_PREFIX}/flashmessages`,
                `${CENTRAL_API_PREFIX}/cart`,
                `${CENTRAL_API_PREFIX}/customer/me`,
            ],
        },
    },
    enable: {
        sentry: false,
    },
});
